export default __webpack_public_path__ + "static/media/equity_icon.a61f51f9.svg";